import apiClient from './axiosClient';

export const getVehicles = () => apiClient.get(`/vehicles/`);
export const getVehicle = (id) => apiClient.get(`/vehicles/${id}/`);
export const createVehicle = (data) => apiClient.post(`/vehicles/`, data);
export const updateVehicle = (id, data) => apiClient.put(`/vehicles/${id}/`, data);
export const deleteVehicle = (id) => apiClient.delete(`/vehicles/${id}/`);

// For linking customers to vehicles
export const createCustomerVehicle = (data) => apiClient.post(`/customer-vehicle/`, data);
export const updateCustomerVehicle = (id, data) => apiClient.put(`/customer-vehicle/${id}/`, data);
export const deleteCustomerVehicle = (customerID, vehicleID) => apiClient.delete(`/customer-vehicle/delete-by-filter/?customer=${customerID}&vehicle=${vehicleID}`);